import React from "react";
import { MessageSquare } from "lucide-react";
import { useSidebar } from "@/components/ui/sidebar";

const ChatTrigger: React.FC = () => {
  const { open, setOpen, openMobile, setOpenMobile, isMobile } = useSidebar();

  // Use the correct open state based on device type
  const isOpen = isMobile ? openMobile : open;

  if (isOpen) return null;

  return (
    <button
      onClick={() => isMobile ? setOpenMobile(true) : setOpen(true)}
      className="fixed bottom-6 left-6 bg-primary hover:bg-primary/90 text-primary-foreground p-4 rounded-full shadow-lg transition-all z-50 hover:scale-105"
      aria-label="Open AI Assistant"
    >
      <MessageSquare size={24} />
    </button>
  );
};

export default ChatTrigger;
